module.exports = __webpack_public_path__ + "static/media/9.14c22d4e.jpeg";